// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"24811c7b","633":"2e8483de","816":"c898e40c"}[chunkId] + ".chunk.js";
};